<template>
  <div style="position: relative">
    <!-- Loading Overlay -->
    <v-overlay v-model="activeLoading" class="align-center justify-center" :persistent="true" contained>
      <v-progress-circular color="primary" indeterminate size="40" width="3" />
    </v-overlay>
    <v-container class="pb-0">
      <span class="text-body-1 mt-2" style="color: #8c1d40; cursor: pointer" @click="backToProfile">
        <v-icon class="mr-2" small color="#8C1D40">mdi-arrow-left</v-icon>
        <span style="text-decoration: underline">Back to edit profile</span>
      </span>
    </v-container>
    <v-container v-if="requestNameChangeUploaded">
      <div>
        <v-col class="headline font-weight-bold mb-3">Thank you!</v-col>
        <v-col class="subheading font-weight-black">Your request has been submitted.</v-col>
        <v-col class="subheading mt-3 mb-4">
          It may take up to 3 business days for your name change to take effect.
        </v-col>
      </div>
    </v-container>
    <v-form ref="form" v-model="valid" v-else>
      <v-container class="pt-0">
        <v-col class="headline font-weight-bold mt-4 mb-3">Edit your name</v-col>
        <v-row wrap>
          <v-col>
            <v-row wrap>
              <v-col class="subheading font-weight-black">Primary Name</v-col>
              <v-col>
                <v-row wrap>
                  <v-col>
                    <v-text-field
                      label="First Name"
                      id="fName"
                      class="text-box-mr"
                      v-model="localFormModel.firstName"
                      @change="
                        asuoDataLayerClick('requestNameChangeModal', '0', {
                          text: localFormModel.firstName
                        });
                        onPasteCheckLanguageforFirstname($event);
                      "
                      :rules="nameRules"
                      @keydown="
                        checkLanguage($event);
                        changeTextToSentenseCase(localFormModel);
                      "
                      required
                      placeholder
                      box
                      style="margin-bottom: -28px"
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      label="Last Name"
                      :class="[{ 'mt-4': $vuetify.display.xs }]"
                      id="fName"
                      v-model="localFormModel.lastName"
                      @change="
                        asuoDataLayerClick('requestNameChangeModal', '1', {
                          text: localFormModel.lastName
                        });
                        onPasteCheckLanguageforFirstname($event);
                      "
                      :rules="nameRules"
                      @keydown="
                        checkLanguage($event);
                        changeTextToSentenseCase(localFormModel);
                      "
                      required
                      placeholder
                      box
                      style="margin-bottom: -28px"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="mt-2 d-none">
            <v-row wrap>
              <v-col class="subheading font-weight-black">Preferred Name</v-col>
              <v-col>
                <v-row wrap>
                  <v-col>
                    <v-text-field
                      label="First Name"
                      id="fName"
                      class="text-box-mr"
                      v-model="localFormModel.preferredFirstName"
                      @change="
                        asuoDataLayerClick('signup', '1', {
                          text: localFormModel.preferredFirstName
                        });
                        onPasteCheckLanguageforFirstname($event);
                      "
                      :rules="nameRules"
                      @keydown="
                        checkLanguage($event);
                        changeTextToSentenseCase(localFormModel);
                      "
                      required
                      placeholder
                      box
                      style="margin-bottom: -28px"
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      label="Last Name"
                      :class="[{ 'mt-4': $vuetify.display.xs }]"
                      id="fName"
                      v-model="localFormModel.preferedLastName"
                      @change="
                        asuoDataLayerClick('signup', '1', {
                          text: localFormModel.preferedLastName
                        });
                        onPasteCheckLanguageforFirstname($event);
                      "
                      :rules="nameRules"
                      @keydown="
                        checkLanguage($event);
                        changeTextToSentenseCase(localFormModel);
                      "
                      required
                      placeholder
                      box
                      style="margin-bottom: -28px"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-col class="subheading mt-3">
          If you are requesting a legal name change, you must submit a photo of your government issued ID showing the
          updated name.
        </v-col>
        <v-col class="headline font-weight-bold mt-3"> Upload your ID photo </v-col>
        <DragAndDropFileZone
          :detectChanges="detectChanges"
          @showUplaodFileConfirmation="showUplaodFileConfirmation"
          @submitRequestNameChange="submitRequestNameChange"
        />
      </v-container>
    </v-form>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import { Helper } from '../mixins/helpers.js';
import { DataLayerMixin } from '../mixins/dataLayerMixin.js';
import { AjaxLoader } from '../mixins/ajaxLoader';
import DragAndDropFileZone from './DragAndDropFileZone.vue';
export default defineComponent({
  emits: ['toggleRequestNameChangeAndEditProfile'],
  name: 'RequestNameChange',
  mixins: [Helper, DataLayerMixin, AjaxLoader],

  data() {
    return {
      dialog: false,
      requestNameChangeUploaded: false,
      valid: true,
      originalNames: {},
      localFormModel: {},
      nameRules: [(v) => !!v || 'This is required', (v) => v.length < 24 || 'Name must be less than 24 characters']
    };
  },

  components: {
    DragAndDropFileZone
  },

  computed: {
    detectChanges() {
      const updatedObject = {};
      const updatedInfosObject = Object.keys(this.originalNames).filter(
        (e) => this.originalNames[e] !== this.localFormModel[e]
      );
      updatedInfosObject.map((e) => (updatedObject[e] = this.localFormModel[e]));
      return updatedObject;
    }
  },

  methods: {
    backToProfile() {
      this.asuoDataLayerClick('editProfileModal', '5');
      this.$emit('toggleRequestNameChangeAndEditProfile');
    },

    showUplaodFileConfirmation() {
      this.requestNameChangeUploaded = !this.requestNameChangeUploaded;
    },

    submitRequestNameChange(param) {
      this.$conn.requestNameChange({
        requestNameChangeFileName: param.imageName,
        requestNameChangeIdPhoto: param.imageSource,
        ...this.detectChanges
      });
    },

    assignNameAndPreferredName() {
      this.originalNames.firstName = this.localFormModel.firstName;
      this.originalNames.lastName = this.localFormModel.lastName;
      this.originalNames.preferredFirstName = this.localFormModel.preferredFirstName;
      this.originalNames.preferedLastName = this.localFormModel.preferedLastName;
    }
  },

  props: {
    formModel: Object
  },

  created() {
    // Create local copy of formModel prop to avoid mutation
    this.localFormModel = { ...this.formModel };
    this.assignNameAndPreferredName();
  }
});
</script>

<style></style>
